import React, { useRef } from 'react';
import { getImageUrlSingleAxis } from './getImageUrl';
import useNodeSize from './useNodeSize';
function ResizeImageImpl(props) {
    const { src, width, maxWidth, aspect, quality, useHeight, ...otherProps } = props;
    const nodeRef = useRef(null);
    const actualSize = useNodeSize(nodeRef, width != null ? [width, width] : undefined);
    function getUrl(multiplier = 1) {
        if (actualSize == null)
            return undefined;
        const nextSize = actualSize.map((v) => {
            const value = v * multiplier;
            if (maxWidth != null && maxWidth < value)
                return maxWidth;
            return value;
        });
        if (useHeight) {
            return getImageUrlSingleAxis(src, nextSize[1], aspect, quality, true);
        }
        return getImageUrlSingleAxis(src, nextSize[0], aspect, quality, false);
    }
    const imageUrl = getUrl(1);
    const srcSet = actualSize != null && src != null
        ? [1.5, 2, 3].map((size) => `${getUrl(size)} ${size}x`).join(',')
        : undefined;
    return (React.createElement("picture", null,
        React.createElement("img", Object.assign({}, otherProps, { src: imageUrl, srcSet: srcSet, ref: nodeRef }))));
}
export const ResizeImage = React.memo(ResizeImageImpl);
//# sourceMappingURL=ResizeImage.js.map